import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { WebSocketLink } from "apollo-link-ws";
import { setContext } from "@apollo/client/link/context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { customFetch } from "./customFetch.js";
import { split } from "apollo-link";
import { getMainDefinition } from "apollo-utilities";
import jwt_decode from "jwt-decode";
import notificationComponent from "../../containers/TheHeaderDropdownNotif";

const httpLink = createHttpLink({
    uri: process.env.VUE_APP_HASURA_URL,
    fetch: customFetch
});

let token = JSON.parse(sessionStorage.getItem("vue-session-key"))?.accessToken;

// const wssLink = new WebSocketLink({
//     uri: process.env.VUE_APP_HASURA_WSS_URL,
//     fetch: customFetch,
//     options: {
//         reconnect: true,
//         timeout: 30000,
//         connectionParams: () => {
//             const session = JSON.parse(
//                 sessionStorage.getItem("vue-session-key")
//             );
//             const accessToken = session.accessToken;
//             return {
//                 headers: {
//                     Authorization: `Bearer ${accessToken}`
//                 }
//             };
//         }
//     }
// });

let wssLink;
const getWssObj = () => {
    wssLink = new WebSocketLink({
        uri: process.env.VUE_APP_HASURA_WSS_URL,
        options: {
            reconnect: true,
            connectionParams: () => {
                return {
                    headers: {
                        Authorization: `Bearer ${
                            JSON.parse(
                                sessionStorage.getItem("vue-session-key")
                            )?.accessToken
                        }`
                    }
                };
            },
            connectionCallback: err => {
                setTimeout(() => {
                    if (err) {
                        try {
                            let token = JSON.parse(
                                sessionStorage.getItem("vue-session-key")
                            )?.accessToken;

                            let decoded = jwt_decode(token);
                            if (
                                decoded &&
                                decoded.exp * 1000 > new Date().getTime()
                            ) {
                                getWssObj();
                                console.log("recalling wss obj");
                            } else {
                                console.log("subscription closed");
                                wssLink.subscriptionClient.close();
                            }
                        } catch (e) {
                            console.log("subscription closed");
                            wssLink.subscriptionClient.close();
                        }
                    }
                }, 0);
            }
        }
    });
    return wssLink;
};

const authLink = setContext((_, { headers }) => {
    const session = JSON.parse(sessionStorage.getItem("vue-session-key"));
    const accessToken = session.accessToken;

    return {
        headers: {
            ...headers,
            Authorization: `Bearer ${accessToken}`
        }
    };
});

const splitLink = split(
    // split based on operation type
    ({ query }) => {
        const definition = getMainDefinition(query);
        return (
            definition.kind === "OperationDefinition" &&
            definition.operation === "subscription"
        );
    },
    getWssObj(),
    authLink.concat(httpLink)
);

export default new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache()
});
